<div class="expanded-info-parent">
  <div class="row">
    <div class="custom-company-title">{{ 'Settings.CompanyLogo' | translate }}</div>
    <div style="display: flex; align-items: center; gap: 5px">
      <button mat-raised-button color="primary" (click)="fileInput.click()">
        <div style="display: flex; align-items: center; gap: 5px">
          <img src="assets/icons/upload.svg" alt width="15" height="15" />
          <div>
            {{ 'Settings.UploadLogo' | translate }}
          </div>
        </div>
      </button>
      <mat-icon
        class="info-icon"
        matTooltip="{{ ('Settings.UploadLogoTitle' | translate) + '\n' + ('Settings.UploadLogoDetails' | translate) }}"
        >info</mat-icon
      >
    </div>
    <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden />

    <div class="icon-container">
      <img
        *ngIf="companiesService.currentCompany.logo && !companiesService.companyLogoErrorState"
        class="img"
        alt
        [src]="companiesService.currentCompany.logo"
        (error)="companiesService.handleImageError()"
        alt
      />
      <!-- <div *ngIf="!companiesService.currentCompany.logo">
        <div class="no-logo">
          {{ 'Settings.NoLogo' | translate }}
        </div>
      </div> -->
      <button *ngIf="companiesService.currentCompany.logo" class="close-button" (click)="removeIcon()">✖</button>
    </div>
  </div>

  <div class="row">
    <div class="custom-company-title">{{ 'Settings.PrimaryColor' | translate }}</div>
    <div style="display: flex; align-items: center; gap: 5px">
      <ng-container *ngFor="let color of primaryColors">
        <div
          class="color-circle"
          [style.background-color]="color.color"
          [style.color]="color.selectedColor"
          (click)="setColor(color, 'primary')"
          onKeyPress
          onKeyDown
          onKeyUp
        >
          <mat-icon *ngIf="color.selected">check</mat-icon>
        </div>
      </ng-container>
      <div
        *ngIf="!customColorSelected.primary"
        class="rainbow-circle"
        (click)="onSelectNewColor('primary')"
        onKeyPress
        onKeyDown
        onKeyUp
      >
        <span style="color: white">+</span>
      </div>
      <div
        *ngIf="customColorSelected.primary"
        class="color-circle"
        [style.background-color]="companiesService.currentCompany.colorPalette.primary"
        style.color="#000"
        (click)="onSelectNewColor('primary')"
        onKeyPress
        onKeyDown
        onKeyUp
      >
        <mat-icon>check</mat-icon>
      </div>
    </div>

    <app-color-selector *ngIf="showColorSelector" (colorChange)="onNewColor($event)"></app-color-selector>
  </div>
</div>
